import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environments';
import { endpoints } from '../endpoints';
import { IContact } from '../models/contact';
import { ErrorService } from '../helpers/errorService';
import internal from 'stream';

@Injectable({
    providedIn: 'root'
})
export class FilesService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    uploadFile(sectionId: string, itemId: number, files: FormData): Observable<{ has_error: boolean, message: string, data: any }> {
        const url = environment.apiBaseUrl + endpoints.uploadFile.replace(':section_id', sectionId).replace(':item_id', itemId.toString());
        return this.http.post<{ has_error: boolean, message: string, data: any }>(url, files).pipe(
            catchError(this.errorService.handleError)
        );
    }


    downloadFile(buildingId: string, sectionId: string, fileId: number): Observable<{ has_error: boolean, message: string, data: { signed_url: string, file_name: string } }> {

        const url = environment.apiBaseUrl + endpoints.downloadFile
            .replace(':building_id', buildingId)
            .replace(':section_id', sectionId)
            .replace(':file_id', fileId.toString());

        return this.http.get<{ has_error: boolean, message: string, data: { signed_url: string, file_name: string } }>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }


    deleteFile(buildingId: string, sectionId: string, fileId: number): Observable<{ has_error: boolean, message: string, data: any }> {
        const url = environment.apiBaseUrl + endpoints.deleteFile
            .replace(':building_id', buildingId)
            .replace(':section_id', sectionId)
            .replace(':file_id', fileId.toString());
        return this.http.delete<{ has_error: boolean, message: string, data: any }>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

}